var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomainNamesLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M15 40C15 38.3431 16.3431 37 18 37H83C84.6569 37 86 38.3431 86 40V61C86 62.6569 84.6569 64 83 64H18C16.3431 64 15 62.6569 15 61V40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M61.9766 50.6167C61.9766 52.8258 60.1857 54.6167 57.9766 54.6167C55.7674 54.6167 53.9766 52.8258 53.9766 50.6167C53.9766 48.4076 55.7674 46.6167 57.9766 46.6167C60.1857 46.6167 61.9766 48.4076 61.9766 50.6167Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M19.8096 50.6167C19.8096 48.4076 21.6004 46.6167 23.8096 46.6167H45.6596C47.8688 46.6167 49.6596 48.4076 49.6596 50.6167C49.6596 52.8258 47.8688 54.6167 45.6596 54.6167H23.8096C21.6004 54.6167 19.8096 52.8258 19.8096 50.6167Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M66.2422 50.6167C66.2422 48.4076 68.033 46.6167 70.2422 46.6167H77.1672C79.3764 46.6167 81.1672 48.4076 81.1672 50.6167C81.1672 52.8258 79.3764 54.6167 77.1672 54.6167H70.2422C68.0331 54.6167 66.2422 52.8258 66.2422 50.6167Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainNamesLight);
export default __webpack_public_path__ + "static/media/domain-names-light.d03756a4615da6293f7ee8d906a8aa7c.svg";
export { ForwardRef as ReactComponent };